import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGridSection from './components/CategoryGridSection';
import ProductShowcaseSection from './components/ProductShowcaseSection';
import TestimonialsSection from './components/TestimonialsSection';
import FullCTASection from './components/FullCTASection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <article>
        <HeroSection />
        <AboutSection />
        <CategoryGridSection />
        <ProductShowcaseSection />
        <TestimonialsSection />
        <NewsletterSection />
        <FullCTASection />
      </article>
      <Footer />
    </main>
  );
}